/**
 * zoneVertexEditUtils — Nachträgliches Verschieben einzelner Zonen-Vertices (#628).
 *
 * Höhenzonen werden im Wizard (Step 4) gezeichnet und leben dort als React-State
 * (`zones: [{ id, vertices, kind, height, ... }]`), wobei `vertices` bereits
 * Welt-/Szenenkoordinaten sind. Diese reine Geometrie-Hilfe schreibt eine neue
 * Vertex-Position in genau eine Zone zurück — ohne Fabric-/React-Abhängigkeiten,
 * damit unit-testbar. Die 3D-Adjazenz/Interpolation (scene3d/terrain.js) wird
 * rein aus den Vertices berechnet und aktualisiert sich dadurch automatisch.
 */

/**
 * Ersetzt den Vertex `index` der Zone `zoneId` durch `point`.
 * Gibt ein neues zones-Array (mit neuer Zonen- und Vertex-Referenz für die
 * betroffene Zone) zurück; unveränderte Zonen bleiben referenzgleich. Bei
 * unbekannter Zone oder ungültigem Index wird das Eingabe-Array unverändert
 * (referenzgleich) zurückgegeben.
 *
 * @param {Array<{id:string, vertices:Array<{x:number,y:number}>}>} zones
 * @param {string} zoneId
 * @param {number} index
 * @param {{x:number,y:number}} point
 * @returns {Array} neues (oder unverändertes) zones-Array
 */
export function updateZoneVertex(zones, zoneId, index, point) {
  if (!Array.isArray(zones) || !point) return zones;

  const zone = zones.find((z) => z && z.id === zoneId);
  if (!zone || !Array.isArray(zone.vertices)) return zones;
  if (!Number.isInteger(index) || index < 0 || index >= zone.vertices.length) {
    return zones;
  }

  return zones.map((z) => {
    if (z.id !== zoneId) return z;
    const vertices = z.vertices.map((v, i) =>
      i === index ? { x: point.x, y: point.y } : { x: v.x, y: v.y }
    );
    return { ...z, vertices };
  });
}
